export const INTERIM_BREAKDOWN_GROUPS_STATE_EVENT = 'interim:breakdown-groups-state-change';
export const INTERIM_BREAKDOWN_GROUPS_REQUEST_STATE_EVENT = 'interim:breakdown-groups-request-state';
export const INTERIM_BREAKDOWN_TOGGLE_ALL_GROUPS_EVENT = 'interim:breakdown-toggle-all-groups';

export interface InterimBreakdownGroupsHeaderState {
  allCollapsed: boolean;
  groupCount: number;
  viewMode?: InterimBookingView;
}

export type InterimBookingView = 'value' | 'percentage' | 'quantity';
export const INTERIM_BREAKDOWN_SET_VIEW_EVENT = 'interim:breakdown-set-view';
export const isInterimBookingView = (value: unknown): value is InterimBookingView =>
  value === 'value' || value === 'percentage' || value === 'quantity';
